import CommonBridge from 'common/CommonBridge';
import Url from 'url';

export const joinParams = (url, query) => {
  return Object.keys(query || {}).reduce((res, cur) => {
    return res + (res.indexOf('?') > -1 ? '&' : '?') + `${cur}=${encodeURIComponent(query[cur])}`;
  }, url);
};
const config = {
  '/mfbs/mstd/product': (uri) => {
    return joinParams(
      `${location.protocol}//${location.host}/commodity/detail/${uri.query.goodsId || uri.query.commodityId}`,
      uri.query,
    );
  },
  '/mfbs/mstd/cart': (uri) => {
    return joinParams(`${location.protocol}//${location.host}/cart`, uri.query);
  },
  '/mfbs/mstd/checkout': (uri) => {
    return joinParams(`${location.protocol}//${location.host}/order/checkout?address_id=`, {
      ...uri.query,
      quick_order: uri.query.quickOrder === 'true' ? '1' : '',
    });
  },
  '/mfbs/mstd/web': (uri) => {
    return uri.query.url;
  },
  // '/mfbs/mstd/joinmore': (uri) => {
  //   const { typeId, couponId, extra_coupon_type_id, extra_coupon_id, activity_id } = uri.query;
  //   if (typeId || couponId || extra_coupon_type_id || extra_coupon_id) {
  //     return joinParams(`${location.protocol}//${location.host}`, uri.query);
  //   } else if (activity_id) {
  //     return uri.href;
  //   } else {
  //     return joinParams(`${location.protocol}//${location.host}/freepostage`, uri.query);
  //   }
  // },
  '/mfbs/mstd/buyShow': (uri) => {
    const map = {
      2: 'question',
      3: 'evaluate',
      1: 'buy',
    };
    return joinParams(`${location.protocol}//${location.host}/micircle`, {
      product_id: uri.query.product_id,
      from: map[uri.query.index],
    });
  },
  '/mfbs/mstd/couponList': (uri) => {
    return joinParams(`${location.protocol}//${location.host}/user/coupon`, uri.query);
  },
};

const urlToAction = (url) => {
  if (!CommonBridge.isMishop()) {
    return url;
  }
  try {
    const result = Url.parse(url, true);
    if (config[result.pathname]) {
      return config[result.pathname](result);
    }
    return url;
  } catch (error) {
    return url;
  }
};

export { urlToAction };
